<script setup lang="ts">
import { onMounted } from 'vue'
import Navbar from '@/components/Navbar.vue'
import PaperAirplane3D from '@/components/PaperAirplane3D.vue'

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

</script>

<template>
  <div class="app-wrapper">
    <PaperAirplane3D />
    <Navbar />
    <main>
      <router-view />
    </main>
  </div>
</template>

<style>
.app-wrapper {
  min-height: 100vh;
  background-color: var(--bg-dark);
  position: relative;
  overflow-x: hidden;
}

main {
  position: relative;
  z-index: 5;
}
</style>